<ng-form #stepForm="ngForm">
    <h3 class="h3">{{'Photos of the store' | translate}}</h3>

    @for (fileData of tradeFileInputsData; track $index; let i = $index) {
    <div class="m-t-5 pos-relative">
        <p class="s2">
            <span [innerHTML]="fileData.label | translate"></span>
            @if (fileData.required) {
            <span class="col-2">*</span>
            }
        </p>
        @if (fileData.upload || !fileData.src) {
        <div class="w-12 m-t-2 pos-relative cursor-pointer button-1">
            <div class="p2 height-100 flex flex-justify-center flex-middle">
                {{ 'Upload' | translate }}
            </div>
            <file-input style="opacity: 0;"
                        [accept]="'.jpg,.jpeg,.png,.webp,.bmp'"
                        [maxSize]="'10M'"
                        (fileChange)="onFileChange($event, fileData)"></file-input>
        </div>
        }
        @if (!fileData.upload && fileData.src) {
        <div class="w-12 m-t-2 pos-relative cursor-pointer button-10">
            <div class="w-12 flex flex-middle flex-justify-between">
                <span class="p1">{{ fileData.name }}</span>
                <span class="flex flex-middle"
                      (click)="upload(fileData)">
                    <span class="p2"
                          [style.line-height]="0">{{ 'Edit' | translate }}</span>
                    <i class="m-l-1 icon-edit"
                       [style.line-height]="0"></i>
                </span>
            </div>
        </div>
        }
        <input-wrap>
            <input type="hidden"
                   [name]="fileData.id"
                   [required]="!!fileData.required"
                   [(ngModel)]="data[fileData.id]">
        </input-wrap>
        <result [status]="fileData.status"></result>
    </div>
    }
</ng-form>